module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container plan-payment-confirmation"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('step', {
    attrs: {
      "currentStep": 3,
      "maxStep": 3
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v("กรอกรายละเอียด")]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v("การชำระเงิน")]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v("ยืนยัน")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v("ยืนยัน")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.selectedPlan.name) + " ")]), _vm._v(" "), _c('br'), _vm._v(" \n                    " + _vm._s(_vm.selectedPlan.detail) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedPlan.duration))]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price)))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("ค่าธรรมเนียม (3.8%)")]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.creditCardFee)))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("รวมทั้งหมด")]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price + _vm.creditCardFee)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {}, [_c('p', [_vm._v(_vm._s(_vm.creditCardDetail.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$guser.user.email))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$guser.user.patient.phone))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.creditCardDetail.city))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.creditCardDetail.postal_code))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row payment-footer"
  }, [_c('div', {
    staticClass: "col-6 form-group text-left"
  }, [_c('router-link', {
    staticClass: "btn btn-link btn-lg",
    attrs: {
      "to": _vm.backLink + _vm.addAppParams
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('action_message.back')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 form-group text-right"
  }, [_c('button', {
    staticClass: "btn btn-store btn-lg",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.confirm
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin fa-fw"
  }) : _vm._e(), _vm._v(" ยืนยัน "), _c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "doneModal",
    attrs: {
      "icon": "success",
      "title": "Done",
      "overlay-theme": "dark"
    },
    on: {
      "close": function($event) {
        _vm.goToSuccessPage()
      }
    }
  }, [_vm._v("\n    You have been subscribed to Zeekdoc\n    "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": function($event) {
        _vm.closeDoneModal()
      }
    },
    slot: "button"
  }, [_vm._v("Ok")])]), _vm._v(" "), _c('sweet-modal', {
    ref: "errorModal",
    attrs: {
      "icon": "error",
      "title": "Something went wrong",
      "overlay-theme": "dark"
    }
  }, [_vm._v("\n    Something went wrong with your payment, please contact admin (027156633)\n    "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": function($event) {
        _vm.closeErrorModal()
      }
    },
    slot: "button"
  }, [_vm._v("Ok")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("สมัครแพลนการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Detail")]), _vm._v(" "), _c('th', [_vm._v("ระยะเวลา")]), _vm._v(" "), _c('th', [_vm._v("ราคา")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65e6009e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/package/payment/step3.vue
// module id = 1022
// module chunks = 1